var _defs, _g, _ellipse, _ellipse2, _path, _path2, _g2, _g3, _path3, _path4, _path5, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path6, _path7, _g4, _ellipse7, _ellipse8, _path8, _path9, _g5, _g6, _path10, _path11, _path12, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVentouses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ventouses",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1465 1173.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#59595b;}.cls-4{fill:#2d2d30;}.cls-5{fill:#7c7c7c;}.cls-6{fill:#666;}.cls-7{fill:#252528;}.cls-8{fill:#1a1a1e;}.cls-9{fill:#d9dee0;}.cls-10{clip-path:url(#clip-path-2);}.cls-11{fill:#848285;}.cls-12{fill:#494949;}.cls-13{clip-path:url(#clip-path-3);}.cls-14{fill:#828185;}.cls-15{fill:#a5a5a5;}.cls-16{fill:#5e5e5e;}.cls-17{fill:#bcbcbc;}.cls-18{fill:#dd5252;}.cls-19{fill:#302f2f;}.cls-20{fill:#7f7f7f;}.cls-21,.cls-22{fill:#e0e0e0;}.cls-21{opacity:0.33;}.cls-22{opacity:0.63;}.cls-23{clip-path:url(#clip-path-4);}.cls-24{clip-path:url(#clip-path-5);}.cls-25{clip-path:url(#clip-path-6);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-229 -384.75)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 669.96,
    cy: 1276.4,
    rx: 354.18,
    ry: 281.21,
    transform: "translate(-70.12 39.34) rotate(-3.2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-229 -384.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M451,1141l-106-81c-57.24-71.81-84.52-140-5-195l416-96c104.7-11.93,128,63,108,161l-54,128-7,2-94-1c-3.54-29.28,5.8-50.4,46-52,28-30.22,46.89-69,59-114,6.18-40.22-8.52-62.23-43-67L386,915c-35.38,14.08-45.86,39-10,84,40.36,36.56,78.13,66.75,107,75,38-17.69,60.81-7.55,73,22l-54,40Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(-229 -384.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M546,1315l-19-71.88,5-2.12c-1-32-20.23-111.09-31-108l-4-1c-2-10.22-.11-17,6-20l282-71c32.11,12,41.29,69.63,49,135,0,0,5.21,21.85,11,30,45.42,64-38.06,90.26-77,35-7.72-6.89-20-7.57-34-6l-83,20c-14.7,4.71-24.25,13.22-28,26C638,1336,564.07,1355.93,546,1315Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(-229 -384.75)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1326.96,
    cy: 893.4,
    rx: 354.18,
    ry: 281.21,
    transform: "translate(-47.74 75.37) rotate(-3.2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(-229 -384.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1108,758l-106-81c-57.24-71.81-84.52-140-5-195l416-96c104.7-11.93,128,63,108,161l-54,128-7,2-94-1c-3.54-29.28,5.8-50.4,46-52,28-30.22,46.89-69,59-114,6.18-40.22-8.52-62.23-43-67l-385,89c-35.38,14.08-45.86,39-10,84,40.36,36.56,78.13,66.75,107,75,38-17.69,60.81-7.55,73,22l-54,40Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(-229 -384.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1203,932l-19-71.88,5-2.12c-1-32-20.23-111.09-31-108l-4-1c-2-10.22-.11-17,6-20l282-71c32.11,12,41.29,69.63,49,135,0,0,5.21,21.85,11,30,45.42,64-38.06,90.26-77,35-7.72-6.89-20-7.57-34-6l-83,20c-14.7,4.71-24.25,13.22-28,26C1295,953,1221.07,972.93,1203,932Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ventouses 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 670.03,
    cy: 1276.59,
    rx: 354.18,
    ry: 281.21,
    transform: "translate(-299.13 -345.41) rotate(-3.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 669.96,
    cy: 1269.4,
    rx: 354.18,
    ry: 281.21,
    transform: "translate(-298.73 -345.42) rotate(-3.2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "769.66 989.79 641.52 885.17 605 741.25 808 857.25 790 990.25 769.66 989.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "76 971.25 246 879.25 263 736.25 153 675.25 0 828.25 27 977.25 76 971.25"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 667.45,
    cy: 1198.06,
    rx: 225.93,
    ry: 174.54,
    transform: "translate(-294.75 -345.68) rotate(-3.2)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 665.1,
    cy: 1182.44,
    rx: 117.83,
    ry: 91.02,
    transform: "translate(-293.89 -345.83) rotate(-3.2)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M806.57,1061.13,833,1170s12-20,12-21v-43l-12-11C827.05,1074.47,820.31,1056.5,806.57,1061.13Z",
    transform: "translate(-229 -384.75)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M290,1290l-17-74c-1.65-8.72.44-12.87,5-14l157-40v-14l59-15c24.74,40,33.4,86.63,33,137l-58,14-12-31-158,39A10.51,10.51,0,0,1,290,1290Z",
    transform: "translate(-229 -384.75)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M451,1141l-106-81c-57.24-71.81-84.52-140-5-195l416-96c104.7-11.93,128,63,108,161l-54,128-7,2-94-1c-3.54-29.28,5.8-50.4,46-52,28-30.22,46.89-69,59-114,6.18-40.22-8.52-62.23-43-67L386,915c-35.38,14.08-45.86,39-10,84,40.36,36.56,78.13,66.75,107,75,38-17.69,60.81-7.55,73,22l-54,40Z",
    transform: "translate(-229 -384.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M354.78,960.26C354.46,933.58,358,909.89,381,901l384-89c35.1.15,54.51,12.44,47.73,45Z",
    transform: "translate(-229 -384.75)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M546,1315l-19-71.88,5-2.12c-1-32-20.23-111.09-31-108l-4-1c-2-10.22-.11-17,6-20l282-71c32.11,12,41.29,69.63,49,135,0,0,5.21,21.85,11,30,45.42,64-38.06,90.26-77,35-7.72-6.89-20-7.57-34-6l-83,20c-14.7,4.71-24.25,13.22-28,26C638,1336,564.07,1355.93,546,1315Z",
    transform: "translate(-229 -384.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M539,1252l296.7-69.56L830,1115l-298,68C537.55,1208.78,540.35,1232.19,539,1252Z",
    transform: "translate(-229 -384.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M519,1133c-4.33-10.12-9.27-17.23-16-21l282-71c11.35,6.1,19.08,12.73,21.57,20.13Z",
    transform: "translate(-229 -384.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M496.24,1124.62c14.76.38,40.13,60.18,34.9,134.14C548,1239,516,1101,496.24,1124.62Z",
    transform: "translate(-229 -384.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M591,1325v10.66l21,.34,228.49-68.8L836,1259c-46,13-52-24-66.56-34.52,0,0-49.28-41.81-80.44-34.48-34,8-58,47-68,72C623.53,1291.7,618.68,1316.28,591,1325Z",
    transform: "translate(-229 -384.75)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M470,1241c-2.69-17.31-6-33.38-11-46l57-12.45a267.93,267.93,0,0,1,9.71,52.69Z",
    transform: "translate(-229 -384.75)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M283,1222l163-44c10.67,27.93,17,53.34,15,74l-164.93,40.24C297.05,1272.83,292.43,1249.22,283,1222Z",
    transform: "translate(-229 -384.75)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M384.35,1174.9c12.17,26.71,19.81,57.17,24.14,90.38l9.59-2.74c-5.41-33.71-12.67-64.82-24.07-90.1Z",
    transform: "translate(-229 -384.75)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 279.5,
    cy: 711.25,
    rx: 23.5,
    ry: 13
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 510,
    cy: 1098,
    rx: 21,
    ry: 11,
    transform: "translate(-289.42 -354.61) rotate(-3.2)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 517.5,
    cy: 649.75,
    rx: 23.5,
    ry: 16.5
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 748,
    cy: 1040,
    rx: 21,
    ry: 11,
    transform: "translate(-285.82 -341.43) rotate(-3.2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M492.35,1105.44S399,1055,362,1018s-52.84-88.08,4-117c-53.43,65.07,3.82,115.21,113,182,10-7,17-6,17-6s-15,2-13,12A32.52,32.52,0,0,0,492.35,1105.44Z",
    transform: "translate(-229 -384.75)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M777.22,1043C852,923.89,892.48,821,801,780c0,0,70,19,65,88-10,81-72.23,178.13-72.23,178.13Z",
    transform: "translate(-229 -384.75)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 1327.03,
    cy: 893.59,
    rx: 354.18,
    ry: 281.21,
    transform: "translate(-276.75 -309.38) rotate(-3.2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1326.96,
    cy: 886.4,
    rx: 354.18,
    ry: 281.21,
    transform: "translate(-276.35 -309.39) rotate(-3.2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1426.66 606.79 1298.52 502.17 1262 358.25 1465 474.25 1447 607.25 1426.66 606.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "733 588.25 903 496.25 920 353.25 810 292.25 657 445.25 684 594.25 733 588.25"
  }))), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1324.45,
    cy: 815.06,
    rx: 225.93,
    ry: 174.54,
    transform: "translate(-272.38 -309.64) rotate(-3.2)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 1322.1,
    cy: 799.44,
    rx: 117.83,
    ry: 91.02,
    transform: "translate(-271.51 -309.8) rotate(-3.2)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1463.57,678.13,1490,787s12-20,12-21V723l-12-11C1484.05,691.47,1477.31,673.5,1463.57,678.13Z",
    transform: "translate(-229 -384.75)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M947,907l-17-74c-1.65-8.72.44-12.87,5-14l157-40V765l59-15c24.74,40,33.4,86.63,33,137l-58,14-12-31L956,909A10.51,10.51,0,0,1,947,907Z",
    transform: "translate(-229 -384.75)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1108,758l-106-81c-57.24-71.81-84.52-140-5-195l416-96c104.7-11.93,128,63,108,161l-54,128-7,2-94-1c-3.54-29.28,5.8-50.4,46-52,28-30.22,46.89-69,59-114,6.18-40.22-8.52-62.23-43-67l-385,89c-35.38,14.08-45.86,39-10,84,40.36,36.56,78.13,66.75,107,75,38-17.69,60.81-7.55,73,22l-54,40Z",
    transform: "translate(-229 -384.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1011.78,577.26c-.32-26.68,3.25-50.37,26.22-59.26l384-89c35.1.15,54.51,12.44,47.73,45Z",
    transform: "translate(-229 -384.75)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1203,932l-19-71.88,5-2.12c-1-32-20.23-111.09-31-108l-4-1c-2-10.22-.11-17,6-20l282-71c32.11,12,41.29,69.63,49,135,0,0,5.21,21.85,11,30,45.42,64-38.06,90.26-77,35-7.72-6.89-20-7.57-34-6l-83,20c-14.7,4.71-24.25,13.22-28,26C1295,953,1221.07,972.93,1203,932Z",
    transform: "translate(-229 -384.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1196,869l296.7-69.56L1487,732l-298,68C1194.55,825.78,1197.35,849.19,1196,869Z",
    transform: "translate(-229 -384.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1176,750c-4.33-10.12-9.27-17.23-16-21l282-71c11.35,6.1,19.08,12.73,21.57,20.13Z",
    transform: "translate(-229 -384.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1153.24,741.62c14.76.38,40.13,60.18,34.9,134.14C1205,856,1173,718,1153.24,741.62Z",
    transform: "translate(-229 -384.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1248,942v10.66l21,.34,228.49-68.8L1493,876c-46,13-52-24-66.56-34.52,0,0-49.28-41.81-80.44-34.48-34,8-58,47-68,72C1280.53,908.7,1275.68,933.28,1248,942Z",
    transform: "translate(-229 -384.75)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1127,858c-2.69-17.31-6-33.38-11-46l57-12.45a267.93,267.93,0,0,1,9.71,52.69Z",
    transform: "translate(-229 -384.75)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M940,839l163-44c10.67,27.93,17,53.34,15,74L953.07,909.24C954.05,889.83,949.43,866.22,940,839Z",
    transform: "translate(-229 -384.75)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1041.35,791.9c12.17,26.71,19.81,57.17,24.14,90.38l9.59-2.74c-5.41-33.71-12.67-64.82-24.07-90.1Z",
    transform: "translate(-229 -384.75)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 936.5,
    cy: 328.25,
    rx: 23.5,
    ry: 13
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 1167,
    cy: 715,
    rx: 21,
    ry: 11,
    transform: "translate(-267.05 -318.58) rotate(-3.2)"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 1174.5,
    cy: 266.75,
    rx: 23.5,
    ry: 16.5
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 1405,
    cy: 657,
    rx: 21,
    ry: 11,
    transform: "translate(-263.44 -305.4) rotate(-3.2)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1149.35,722.44S1056,672,1019,635s-52.84-88.08,4-117c-53.43,65.07,3.82,115.21,113,182,10-7,17-6,17-6s-15,2-13,12A32.52,32.52,0,0,0,1149.35,722.44Z",
    transform: "translate(-229 -384.75)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1434.22,660C1509,540.89,1549.48,438,1458,397c0,0,70,19,65,88-10,81-72.23,178.13-72.23,178.13Z",
    transform: "translate(-229 -384.75)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentouses);
export default __webpack_public_path__ + "static/media/ventouses.bf5a6c7fd85d923195ddf3c1f2ab8a85.svg";
export { ForwardRef as ReactComponent };